import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import * as FilePond from 'filepond'
import fr_fr from 'filepond/locale/fr-fr.js';
import { Alert } from '../functions'

const object = vnObject
const { __ } = wp.i18n
let redirectToManagePlanPage = false

FilePond.setOptions(fr_fr);

const updatePlaceForm = $('.js-update-place-form')

const mainImagePond = FilePond.create(document.querySelector('.filepond-main-image'), {
    acceptedFileTypes: [
        'image/jpeg',
        'image/png',
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const galleryImagesPond = FilePond.create(document.querySelector('.filepond-gallery-images'), {
    acceptedFileTypes: [
        'image/jpeg',
        'image/png',
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
    allowMultiple: true,
});

if (updatePlaceForm.length) {
    updatePlaceForm.parsley().on('form:success', function () {
        updatePlaceForm.attr('data-success', 'true')
    })

    updatePlaceForm.parsley().on('form:error', function () {
        updatePlaceForm.attr('data-success', 'false')
    })

    updatePlaceForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()
        tinymce.triggerSave()

        const formData = new FormData(updatePlaceForm[0])
        formData.append('action', 'vn_update_place')
        formData.append('nonce', object.nonce)

        var pondFiles = mainImagePond.getFiles();
        if ( pondFiles[0] ) {
            formData.append('main_image', pondFiles[0].file);
        }

        var pondGalleryFiles = galleryImagesPond.getFiles();
        pondGalleryFiles.forEach((fileItem, index) => {
            formData.append('gallery_images[]', fileItem.file);
        });


        const placeSuitableFor = [];
        $('.js-place-suitable-checkbox input[type="checkbox"]:checked').each(function() {
            placeSuitableFor.push($(this).val());
        });
        formData.append('place_suitable_for', placeSuitableFor);

        const placeTypes = [];
        $('.js-place-type-checkbox input[type="checkbox"]:checked').each(function() {
            placeTypes.push($(this).val());
        });
        formData.append('place_type', placeTypes);

        const $updatePlaceForm = updatePlaceForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $updatePlaceForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $updatePlaceForm.removeClass('sending')

                Alert(res.success, res.data.message)
                if ( redirectToManagePlanPage ) {
                    window.location = object.managePlanPage;
                }
                else if (res.success && res.data.redirect) {
                    window.location = res.data.redirect;
                } else {
                    location.reload();
                }

                redirectToManagePlanPage = false;
            },
        })
    })
}

$('.js-place-cat-radio').on('click', function() {
    $('.js-place-cat-radio').removeClass('selected');
    $(this).addClass('selected');
    $(this).find('input[type="radio"]').prop('checked', true);
});

$('.js-place-suitable-checkbox').on('click', function() {
    var $checkbox = $(this).find('input[type="checkbox"]');
    var isChecked = $checkbox.prop('checked');
    $checkbox.prop('checked', !isChecked);
});

$('.js-place-type-checkbox').on('click', function() {
    var $checkbox = $(this).find('input[type="checkbox"]');
    var isChecked = $checkbox.prop('checked');
    $checkbox.prop('checked', !isChecked);
});



const input = document.getElementById('establishment_name');

if ( input != undefined ) {
    var $latitudeInput = $('#latitude');
    var $longitudeInput = $('#longitude');
    var $zipCodeInput = $('#zip_code');
    var $cityInput = $('#city');
    var $departmentInput = $('#department');
    var $regionInput = $('#region');
    var $addressInput = $('#address');
    var $placeIdInput = $('#google_place_id');
    var $countryInput = $('#country');

    const options = {
        fields: ['address_components', 'name', 'geometry', 'place_id'],
        types: ['establishment'],
        componentRestrictions: { country: 'fr' },
        strictBounds: false,
    };

    const addressSearchBox = new google.maps.places.Autocomplete(input, options);

    addressSearchBox.addListener('place_changed', () => {
        const place = addressSearchBox.getPlace();

        if (!place.geometry) {
            console.log("No details available for input: '" + place.name + "'");
            return;
        }

        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const placeId = place.place_id;

        let postalCode = '';
        let city = '';
        let department = '';
        let region = '';
        let streetNumber = '';
        let streetName = '';
        let country = '';

        for (const component of place.address_components) {
            if (component.types.includes('postal_code')) {
                postalCode = component.long_name;
            }
            if (component.types.includes('locality')) {
                city = component.long_name;
            }
            if (component.types.includes('administrative_area_level_2')) {
                department = component.long_name;
            }
            if (component.types.includes('administrative_area_level_1')) {
                region = component.long_name;
            }
            if (component.types.includes('street_number')) {
                streetNumber = component.long_name + ' ';
            }
            if (component.types.includes('route')) {
                streetName = component.long_name;
            }
            if (component.types.includes('country')) {
                country = component.long_name;
            }
        }

        $latitudeInput.val(latitude);
        $longitudeInput.val(longitude);
        $zipCodeInput.val(postalCode);
        $cityInput.val(city);
        $departmentInput.val(department);
        $regionInput.val(region);
        $addressInput.val(streetNumber + streetName );
        $placeIdInput.val(placeId);
        $countryInput.val(country);
    });

}


$('.js-repeater__add').on( 'click', function() {
    let counter = $(this).data('count');
    let day = $(this).data('day');
    let newItem = `
            <div class="pt-update-place__schedule-item">
                <div class="pt-update-place__open-section">
                    <div class="pt-update-place__sub-section--title">${__('Opening', 'vn')}</div>
                    <div class="totem-input totem-input--classic">
                        <input type="time" id="${day}_opening_${counter}" name="${day}_opening_${counter}">
                    </div>
                </div>
                <div class="pt-update-place__close-section">
                    <div class="pt-update-place__sub-section--title">${__('Closing', 'vn')}</div>
                    <div class="totem-input totem-input--classic">
                        <input type="time" id="${day}_closing_${counter}" name="${day}_closing_${counter}">
                    </div>
                </div>
                <div class="pt-update-place__schedule-remove js-repeater__remove"><i class="vn-icons-delete"></i></div>
            </div>
        `;
    counter ++;
    $(this).data('count', counter)
    $(this).parent('.js-repeater').append(newItem);
});

$(document).on('click', '.js-repeater__remove', function() {
    $(this).parent('.pt-update-place__schedule-item').remove();
});

function toggleSelectAndRepeater() {
    $('.pt-update-place__schedule-section').each(function() {
        const $parent = $(this);
        const $scheduleClose = $parent.find('.schedule_close');
        const $copyDay = $parent.find('.js-copy-day');
        const $repeater = $parent.find('.js-repeater');

        if ($scheduleClose.is(':checked')) {
            if ($copyDay.is(':visible') || $repeater.is(':visible')) {
                $copyDay.slideUp();
                $repeater.slideUp();
            }
        } else {
            if ($copyDay.is(':hidden') || $repeater.is(':hidden')) {
                $copyDay.slideDown();
                toggleRepeater($parent);
            }
        }
    });
}

function toggleRepeater($parent) {
    const $scheduleCopyDay = $parent.find('.schedule_copy_day');
    const $repeater = $parent.find('.js-repeater');

    if ($scheduleCopyDay.val() !== '') {
        if ($repeater.is(':visible')) {
            $repeater.slideUp();
        }
    } else {
        if ($repeater.is(':hidden')) {
            $repeater.slideDown();
        }
    }
}

$(document).on('change', '.schedule_close', function() {
    toggleSelectAndRepeater();
});

$(document).on('change', '.schedule_copy_day', function() {
    const $parent = $(this).closest('.pt-update-place__schedule-section');
    toggleRepeater($parent);
});

$(document).ready(function() {
    toggleSelectAndRepeater();
    $('.pt-update-place__schedule-section').each(function() {
        const $parent = $(this);
        toggleRepeater($parent);
    });
});

$('.js-repeater__add').on( 'click', function() {
    let counter = $(this).data('count');
    let day = $(this).data('day');
    let newItem = `
            <div class="pt-update-place__schedule-item">
                <div class="pt-update-place__open-section">
                    <div class="pt-update-place__sub-section--title">${__('Opening', 'vn')}</div>
                    <div class="totem-input totem-input--classic">
                        <input type="time" id="${day}_opening_${counter}" name="${day}_opening_${counter}">
                    </div>
                </div>
                <div class="pt-update-place__close-section">
                    <div class="pt-update-place__sub-section--title">${__('Closing', 'vn')}</div>
                    <div class="totem-input totem-input--classic">
                        <input type="time" id="${day}_closing_${counter}" name="${day}_closing_${counter}">
                    </div>
                </div>
                <div class="pt-update-place__schedule-remove js-repeater__remove"><i class="vn-icons-delete"></i></div>
            </div>
        `;
    counter ++;
    $(this).data('count', counter)
    $(this).parent('.js-repeater').append(newItem);
});

$(document).on('click', '.js-repeater__remove', function() {
    $(this).parent('.pt-update-place__schedule-item').remove();
});

$('.js-faq-repeater__add').on( 'click', function() {
    let counter = $(this).data('count');
    let newItem = `
            <div class="pt-update-place__faq-item">
                <input
                        type="text"
                        id="question_${counter}"
                        name="question_${counter}"
                        placeholder="${__('Question', 'vn')}"
                        value=""
                >
    
                <textarea
                        type="text"
                        class="faq_answer"
                        id="answer_${counter}"
                        name="answer_${counter}"
                        placeholder="${__('Answer', 'vn')}"
                ></textarea>
                <div class="pt-update-place__faq-remove js-faq-repeater__remove"><i class="vn-icons-delete"></i></div>
            </div>
        `;
    counter ++;
    $(this).data('count', counter)
    $(this).parent('.js-faq-repeater').append(newItem);

    initFaqWysiwyg()
});

$(document).on('click', '.js-faq-repeater__remove', function() {
    $(this).parent('.pt-update-place__faq-item').remove();
});

// Add tools to textarea fields
jQuery(document).ready(function($) {
    jQuery(document).ready(function($) {
        if (typeof tinymce !== 'undefined') {
            tinymce.init({
                selector: '#short_description_text, #closing_times, #accessibility, #long_description, #faq_zone',
                menubar: false,
                toolbar: 'fullscreen undo redo | bold italic underline strikethrough |',
                branding: false
            });
            initFaqWysiwyg()
    }
    });
});

function initFaqWysiwyg () {
    tinymce.init({
        selector: '.faq_answer',
        menubar: false,
        toolbar: 'fullscreen undo redo | bold italic underline strikethrough |',
        branding: false,
        setup: function (editor) {
            editor.on('keydown', function (e) {
                let content = editor.getContent({ format: 'text' });

                // Permettre certaines touches comme les flèches, backspace, etc.
                if (content.length >= 500 && e.keyCode !== 8 && e.keyCode !== 46 && (e.keyCode < 37 || e.keyCode > 40)) {
                    e.preventDefault(); // Empêche la saisie supplémentaire
                    alert(__('You have reached the 500 character limit.', 'vn'));
                }
            });
        }
    });
}

$('.js-open-not-premium-modal').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var modalElement = document.getElementById('notPremium');
    if (modalElement) {
        $('#notPremium').modal('show');
    }
});

$('.js-stripe-submit').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    redirectToManagePlanPage = true
    updatePlaceForm.trigger('submit');
});